import { EventStream } from "@iventis/utilities";

export enum RelayTimetableSplitEvent {
    LineSplitPending = "LineSplitPending",
    LineSplit = "LineSplit",
    LineSplitSettled = "LineSplitSettled",
}

/** The pieces a line was split into, in order along it, on the layer the line was on, and the line they replaced */
interface RelayTimetableSplitPieces {
    splitObjectIds: string[];
    layerId: string;
    splitLineObjectId: string;
}

/**
 * How the map tells the relay timetable about a line being split, whether or not the timetable is open.
 *
 * A split is announced three times. Pending is sent as soon as the map has split the line, before the line is deleted
 * from the backend or its pieces created there, so an open timetable can hold off showing either until the split has
 * settled. LineSplit is sent once the map has finished creating the pieces, whether or not that succeeded, with the place
 * the line held in the timetable, which the first piece takes. The place is left out when the map did not hold it for
 * the line, in which case the pieces take the place the timetable gives them. Settled is sent once the pieces have their
 * places and the timetable has been told to read the day again, so the objects held off can be shown. Every pending
 * split is followed by both, so nothing is held off for good.
 */
export type RelayTimetableSplitEventMessage =
    | { type: RelayTimetableSplitEvent.LineSplitPending; payload: RelayTimetableSplitPieces }
    | { type: RelayTimetableSplitEvent.LineSplit; payload: RelayTimetableSplitPieces & { order: number | undefined } }
    | { type: RelayTimetableSplitEvent.LineSplitSettled; payload: RelayTimetableSplitPieces };

export const relayTimetableSplitEventStream = new EventStream<RelayTimetableSplitEventMessage>();
